export const EDIT_SUCCESS = 'Оператор ЭЗС обновлен';
export const EDIT_ERROR = 'Не удалось обновить оператора ЭЗС';
